import {
  groupLifeProposalsService,
  type GroupLifeCommercialLetterPayload,
} from '@/services/proposals/group-life';
import { downloadFromSignedUrl } from '@/shared/utils/signed-url.util';
import { useMutation } from '@tanstack/react-query';

export function useGenerateGroupLifeCommercialLetter(policyId: string) {
  return useMutation({
    mutationKey: ['group-life-proposal', policyId, 'commercial-letter'],
    mutationFn: async (payload: GroupLifeCommercialLetterPayload) => {
      const result = await groupLifeProposalsService.commercialLetter({
        policyId,
        payload,
      });
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Erro ao gerar a carta comercial');
      }
      const filename =
        result.data.key.split('/').pop() || `carta-comercial-${policyId}.pdf`;
      await downloadFromSignedUrl(result.data.url, filename);
      return result.data;
    },
  });
}
